import React from 'react';
import { ButtonGroup } from '@trevor/ui-components';
import { useSetInitialUrl } from '../hooks/useSetInitialUrl';
import { useTrackNavigation } from '../hooks/useTrackNavigation';
import { useHandleKeyCombinations } from '../hooks/useHandleKeyCombinations';
import { UndoButton } from './UndoButton';
import { RedoButton } from './RedoButton';

export const UndoRedo = () => {
  useSetInitialUrl();
  useTrackNavigation();
  useHandleKeyCombinations();

  return (
    <ButtonGroup>
      <UndoButton />
      <RedoButton />
    </ButtonGroup>
  );
};
